import { css } from 'styled-components';
import {
  BACKGROUND_HORIZONTAL_PADDING,
  BACKGROUND_VERTICAL_PADDING
} from './background';

export function clickableZone() {
  return css<{
    _hasBackground: boolean;
    _withSlash: boolean;
    _columnGap: number;
    _displayDeactivation?: boolean;
  }>`
    &::after {
      content: '';
      pointer-events: ${({ _displayDeactivation = false }) =>
        _displayDeactivation ? 'none' : 'auto'};
      border-radius: inherit;
      position: absolute;
      width: 100%;
      height: 100%;

      ${({ _hasBackground, _withSlash, _columnGap }) => {
        const verticalPadding = _hasBackground
          ? BACKGROUND_VERTICAL_PADDING
          : 0;
        const horizontalPadding = _columnGap / 2;
        const left = _withSlash ? 0 : horizontalPadding;

        return `
        padding: ${verticalPadding}px ${horizontalPadding}px;
        top: -${verticalPadding}px;
        left: -${left}px;
      `;
      }}
    }

    &:only-child::after {
      ${({ _hasBackground }) => {
        const left = _hasBackground ? BACKGROUND_HORIZONTAL_PADDING : 0;
        const padding = _hasBackground ? BACKGROUND_VERTICAL_PADDING : 0;

        return `
        padding: ${padding}px;
        left: -${left}px;
        width: calc(100% + ${padding}px);
      `;
      }}
    }

    &:not(:only-child):first-child::after {
      ${({ _hasBackground, _withSlash, _columnGap }) => {
        const left = _hasBackground ? BACKGROUND_HORIZONTAL_PADDING : 0;
        const rightPadding = _withSlash ? left + _columnGap / 2 : left;

        return `
        left: -${left}px;
        padding-right: ${rightPadding}px;
      `;
      }}
    }

    &:not(:only-child):last-child::after {
      ${({ _hasBackground, _withSlash, _columnGap }) => {
        const additionalSpace = _columnGap / 2;
        const left = _withSlash ? 0 : additionalSpace;
        const rightPadding = _withSlash
          ? BACKGROUND_HORIZONTAL_PADDING - additionalSpace
          : BACKGROUND_HORIZONTAL_PADDING;

        return `
        left: -${left}px;
        padding-right: ${_hasBackground ? rightPadding : 0}px;
      `;
      }}
    }
  `;
}
